/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Igs_Stierstadt5Inputs */

const en__field__enum_schoolname_igs_stierstadt5 = /** @type {(inputs: _Field__Enum_Schoolname_Igs_Stierstadt5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stierstadt`)
};

const de__field__enum_schoolname_igs_stierstadt5 = /** @type {(inputs: _Field__Enum_Schoolname_Igs_Stierstadt5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGS Stierstadt`)
};

/**
* | output |
* | --- |
* | "Stierstadt" |
*
* @param {_Field__Enum_Schoolname_Igs_Stierstadt5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_igs_stierstadt5 = /** @type {((inputs?: _Field__Enum_Schoolname_Igs_Stierstadt5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Igs_Stierstadt5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_igs_stierstadt5(inputs)
	return de__field__enum_schoolname_igs_stierstadt5(inputs)
});
export { _field__enum_schoolname_igs_stierstadt5 as "_field__enum_schoolName_IGS_Stierstadt" }